

import { LayoutCrearDoc } from "../../layouts"
import { TablaProveedores } from "../components";
import { useNavigate } from "react-router-dom";
import { useTodosProveedores } from "../../../hooks/cache";
import { CargandoMedio } from "../../components";
import { BuscadorXTermino } from "../../components/buscadores";




export const ListadoProveedores = () => {


    const navigate = useNavigate();
    const { data, isLoading, termino, chageTermino, chagePage, page } = useTodosProveedores();


    const handleNavegar = () => {
        navigate(`/super/crear-proveedor/new`)
    }


    return (

        <LayoutCrearDoc titulo='Listado de Proveedores' funcion={ handleNavegar }>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de proveedores..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="proveedor" playhol="nombre nit movil" />
                <TablaProveedores data={data || []} chagePage={chagePage} page={page} />
                </>
            }
        </LayoutCrearDoc>
    )
}
